import { MIN_DESKTOP, MIN_TABLET } from "../constants";

export default {
    isMobile: false,
    isPhone: false,
    isTablet: false,
    isDesktop: false,
    onResize() {
        this.isDesktop = window.innerWidth >= MIN_DESKTOP;
        this.isMobile = window.innerWidth < MIN_DESKTOP;
        this.isTablet = window.innerWidth >= MIN_TABLET && window.innerWidth < MIN_DESKTOP;
        this.isPhone = window.innerWidth < MIN_TABLET;
    },
    init() {
        this.onResize();
        addEventListener("resize", this.onResize.bind(this));
    }
};